<template>
  <section
    class="sec topchoice reveal"
    id="top-choice"
    data-ga-section="top_choice"
  >
    <div class="tc-wrap">
      <div class="topchoice-head">
        <span class="tc-badge">
          <icon-crown-badge />
          {{ trans.get('landing.top_choice.badge') }}
        </span>
        <div class="tc-head-row">
          <h2 class="sec-title">
            {{ trans.get('landing.top_choice.title_line1_prefix')
            }}<span class="grad">{{ trans.get('landing.top_choice.title_line1_grad') }}</span
            ><br />{{ trans.get('landing.top_choice.title_line2') }}
          </h2>
        </div>
        <p class="sec-lede">
          {{ trans.get('landing.top_choice.lede_prefix')
          }}<strong>{{ trans.get('landing.top_choice.lede_strong') }}</strong
          >{{ trans.get('landing.top_choice.lede_suffix') }}
        </p>
      </div>

      <div
        class="tc-carousel"
        role="list"
      >
        <a
          v-for="card in cards"
          :key="card.key"
          href="#"
          class="tc-card"
          :class="{ spotlight: card.spotlight }"
          role="listitem"
          :aria-label="card.ariaLabel"
          @click.prevent="openSignup"
        >
          <div class="tc-photo">
            <picture>
              <source
                type="image/webp"
                :srcset="require('../../../../../images/viluu/landing-v2/profiles/' + card.photo + '.webp')"
              />
              <img
                :src="require('../../../../../images/viluu/landing-v2/profiles/' + card.photo + '.png')"
                :alt="trans.get(card.nameKey)"
                loading="lazy"
                decoding="async"
                width="240"
                height="240"
              />
            </picture>
          </div>
          <div
            v-if="card.spotlight"
            class="tc-shine"
            aria-hidden="true"
          ></div>
          <span class="tc-pill">{{ trans.get(card.pillKey) }}</span>
          <span
            v-if="card.spotlight"
            class="tc-crown"
            aria-hidden="true"
          >
            <icon-crown />
          </span>
          <div class="tc-info">
            <div class="tc-name">
              {{ trans.get(card.nameKey) }}
              <span
                v-if="card.online"
                class="tc-online"
                aria-hidden="true"
              ></span>
            </div>
            <div class="tc-meta">
              <icon-map-marker
                :size="13"
                :stroke-width="2.2"
              />
              {{ trans.get(card.cityKey) }}
            </div>
          </div>
        </a>
      </div>

      <div
        class="tc-swipe-hint"
        aria-hidden="true"
      >
        <span class="sh-dots"><span></span><span></span><span></span><span></span></span>
        <span>{{ trans.get('landing.top_choice.swipe_hint') }}</span>
        <span class="sh-arrow"><icon-arrow-right :size="14" /></span>
      </div>

      <div class="tc-actions">
        <button
          class="btn-primary"
          type="button"
          data-cta-location="top_choice"
          @click="openSignup"
        >
          <strong>{{ trans.get('landing.top_choice.cta') }}</strong>
          <span class="arrow">→</span>
        </button>
        <a
          href="#faq"
          class="tc-ghost"
          data-ga-content-link
          data-ga-section="top_choice"
        >
          {{ trans.get('landing.top_choice.how_link') }}
          <icon-arrow-right :size="14" />
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import IconCrownBadge from '../icons/IconCrownBadge.vue';
import IconCrown from '../icons/IconCrown.vue';
import IconMapMarker from '../icons/IconMapMarker.vue';
import IconArrowRight from '../icons/IconArrowRight.vue';

export default {
  name: 'TopChoiceSection',
  components: { IconCrownBadge, IconCrown, IconMapMarker, IconArrowRight },
  data() {
    return {
      cards: [
        {
          key: 'c1',
          photo: 'lena',
          spotlight: true,
          online: true,
          nameKey: 'landing.top_choice.card1_name',
          cityKey: 'landing.top_choice.card1_city',
          pillKey: 'landing.top_choice.card1_pill',
        },
        {
          key: 'c2',
          photo: 'sophia',
          spotlight: false,
          online: false,
          nameKey: 'landing.top_choice.card2_name',
          cityKey: 'landing.top_choice.card2_city',
          pillKey: 'landing.top_choice.card2_pill',
        },
        {
          key: 'c3',
          photo: 'mara',
          spotlight: false,
          online: true,
          nameKey: 'landing.top_choice.card3_name',
          cityKey: 'landing.top_choice.card3_city',
          pillKey: 'landing.top_choice.card3_pill',
        },
        {
          key: 'c4',
          photo: 'anna',
          spotlight: false,
          online: false,
          nameKey: 'landing.top_choice.card4_name',
          cityKey: 'landing.top_choice.card4_city',
          pillKey: 'landing.top_choice.card4_pill',
        },
        {
          key: 'c5',
          photo: 'carla',
          spotlight: false,
          online: true,
          nameKey: 'landing.top_choice.card5_name',
          cityKey: 'landing.top_choice.card5_city',
          pillKey: 'landing.top_choice.card5_pill',
        },
      ],
    };
  },
  methods: {
    openSignup() {
      this.$eventHub.$emit('viluu-landing:open-signup', {
        mode: 'register',
        cta_location: 'top_choice',
      });
    },
  },
};
</script>
<style scoped lang="scss">
.sec.topchoice {
  position: relative;
  background: linear-gradient(
    180deg,
    transparent 0%,
    #fff0e6 18%,
    #ffe9d6 50%,
    #fff0e6 82%,
    transparent 100%
  );
  max-width: none;
}

.topchoice .tc-wrap {
  max-width: 1480px;
  margin: 0 auto;
  padding: 0 56px;
}

.topchoice .topchoice-head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  margin-bottom: 48px;
  position: relative;
}

.topchoice .tc-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 99px;
  background: linear-gradient(135deg, var(--coral), var(--pink));
  color: #fff;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  box-shadow: 0 12px 24px -8px rgba(198, 62, 124, 0.5);
}

.topchoice .tc-badge svg {
  width: 14px;
  height: 14px;
}

.topchoice .sec-title {
  margin: 0;
  text-wrap: balance;
}

strong {
  font-weight: 800;
}

.topchoice .tc-head-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
}

.topchoice .sec-lede {
  max-width: 520px;
}

.tc-carousel {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1fr 1fr;
  gap: 18px;
  align-items: start;
  margin-bottom: 40px;
}

.tc-card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  aspect-ratio: 3/4;
  border-radius: 24px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  background: #fff;
  box-shadow: 0 14px 28px -10px rgba(26, 12, 20, 0.18), 0 4px 10px -2px rgba(26, 12, 20, 0.06);
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.35s ease;
  cursor: pointer;
}

.tc-card::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 2px;
  background: linear-gradient(
    160deg,
    rgba(241, 124, 8, 0.55),
    rgba(198, 62, 124, 0.6),
    rgba(255, 255, 255, 0) 75%
  );
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
  z-index: 2;
}

.tc-card.spotlight {
  aspect-ratio: 3/4.4;
  box-shadow: 0 24px 50px -16px rgba(198, 62, 124, 0.45), 0 8px 18px -6px rgba(26, 12, 20, 0.12);
}

.tc-card.spotlight::before {
  background: linear-gradient(
    160deg,
    rgba(241, 124, 8, 0.85),
    rgba(198, 62, 124, 0.85),
    rgba(255, 255, 255, 0) 80%
  );
  padding: 2.5px;
}

.tc-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 30px 60px -18px rgba(198, 62, 124, 0.5), 0 12px 24px -6px rgba(26, 12, 20, 0.18);
}

.tc-card .tc-photo {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.tc-card .tc-photo img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.tc-card .tc-photo::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(20, 5, 15, 0) 40%, rgba(20, 5, 15, 0.7) 100%);
  z-index: 1;
}

.tc-card .tc-pill {
  position: absolute;
  top: 14px;
  left: 14px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  padding: 6px 12px;
  border-radius: 99px;
  font-size: 11px;
  font-weight: 700;
  color: var(--ink);
  z-index: 3;
  letter-spacing: 0.02em;
  box-shadow: 0 4px 10px -2px rgba(20, 5, 15, 0.15);
}

.tc-card .tc-crown {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--coral), var(--pink));
  color: #fff;
  display: grid;
  place-items: center;
  z-index: 3;
  box-shadow: 0 8px 18px -4px rgba(198, 62, 124, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.tc-card .tc-crown svg {
  width: 16px;
  height: 16px;
}

.tc-card .tc-info {
  position: relative;
  z-index: 3;
  padding: 16px;
  color: #fff;
}

.tc-card .tc-name {
  font-family: var(--display);
  font-weight: 700;
  font-size: 22px;
  letter-spacing: -0.01em;
  line-height: 1.1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tc-card .tc-name .tc-online {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.4);
  animation: pulse 2s infinite;
}

.tc-card .tc-meta {
  font-size: 13px;
  opacity: 0.85;
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tc-card .tc-meta svg {
  flex-shrink: 0;
  opacity: 0.8;
}

.tc-card.spotlight .tc-name {
  font-size: 28px;
}

.tc-card.spotlight .tc-shine {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    120deg,
    transparent 30%,
    rgba(255, 255, 255, 0.25) 50%,
    transparent 70%
  );
  background-size: 200% 100%;
  animation: shine 4s ease-in-out infinite;
  pointer-events: none;
  z-index: 2;
}

.tc-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.tc-ghost {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--ink-dim);
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.15s ease;
}

.tc-ghost:hover {
  color: var(--pink);
}

.tc-ghost svg {
  transition: transform 0.2s ease;
}

.tc-ghost:hover svg {
  transform: translateX(3px);
}

.tc-swipe-hint {
  display: none;
}

@media (max-width: 1100px) {
  .topchoice .tc-wrap {
    padding: 0 28px;
  }
  .tc-carousel {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding: 4px 28px 24px 0;
    margin: 0 -28px 32px;
    gap: 14px;
    scroll-padding-left: 28px;
    -webkit-mask-image: linear-gradient(
      90deg,
      transparent 0,
      #000 28px,
      #000 calc(100% - 40px),
      transparent 100%
    );
    mask-image: linear-gradient(
      90deg,
      transparent 0,
      #000 28px,
      #000 calc(100% - 40px),
      transparent 100%
    );
  }
  .tc-carousel::-webkit-scrollbar {
    display: none;
  }
  .tc-carousel {
    scrollbar-width: none;
  }
  .tc-card {
    flex: 0 0 76%;
    min-width: 260px;
    scroll-snap-align: start;
    aspect-ratio: 3/4.2;
  }
  .tc-card.spotlight {
    flex: 0 0 82%;
    aspect-ratio: 3/4.4;
  }
  .tc-swipe-hint {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin: -8px 0 28px;
    padding: 10px 18px;
    background: #fff;
    border: 1px solid var(--line);
    border-radius: 99px;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    font-size: 12.5px;
    font-weight: 600;
    color: var(--ink-dim);
    letter-spacing: 0.01em;
    box-shadow: 0 4px 12px -6px rgba(20, 5, 15, 0.1);
    line-height: normal;
  }
  .tc-swipe-hint .sh-dots {
    display: flex;
    gap: 4px;
  }
  .tc-swipe-hint .sh-dots span {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--line);
    transition: background 0.3s ease;
    animation: shDots 2.4s ease-in-out infinite;
  }
  .tc-swipe-hint .sh-dots span:nth-child(1) {
    animation-delay: 0s;
  }
  .tc-swipe-hint .sh-dots span:nth-child(2) {
    animation-delay: 0.6s;
  }
  .tc-swipe-hint .sh-dots span:nth-child(3) {
    animation-delay: 1.2s;
  }
  .tc-swipe-hint .sh-dots span:nth-child(4) {
    animation-delay: 1.8s;
  }
  .tc-swipe-hint .sh-arrow {
    display: inline-flex;
    color: var(--pink);
    animation: shArrow 1.8s ease-in-out infinite;
  }
}

@media (max-width: 520px) {
  .topchoice .tc-wrap {
    padding: 0 20px;
  }
  .tc-carousel {
    padding: 4px 20px 24px 0;
    margin: 0 -20px 28px;
    scroll-padding-left: 20px;
  }
  .tc-card {
    flex: 0 0 80%;
  }
}

@keyframes shine {
  0%,
  40% {
    background-position: 200% 0;
  }

  60%,
  100% {
    background-position: -100% 0;
  }
}

@media (max-width: 1100px) {
  @keyframes shDots {
    0%,
    80%,
    100% {
      background: var(--line);
    }

    40% {
      background: var(--pink);
    }
  }
  @keyframes shArrow {
    0%,
    100% {
      transform: translateX(0);
    }

    50% {
      transform: translateX(4px);
    }
  }
}
</style>
